var _metadata, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAjustesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICOS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,94.5c-24.54,0-44.5-19.96-44.5-44.5S25.46,5.5,50,5.5s44.5,19.96,44.5,44.5-19.96,44.5-44.5,44.5ZM50,7.98C26.83,7.98,7.98,26.83,7.98,50s18.85,42.02,42.02,42.02,42.02-18.85,42.02-42.02S73.17,7.98,50,7.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.83,37.94c-4.46,0-8.09-3.63-8.09-8.09s3.63-8.09,8.09-8.09,8.09,3.63,8.09,8.09-3.63,8.09-8.09,8.09ZM36.83,24.25c-3.09,0-5.61,2.52-5.61,5.61s2.52,5.61,5.61,5.61,5.61-2.51,5.61-5.61-2.51-5.61-5.61-5.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.91,50.49c-4.46,0-8.09-3.63-8.09-8.09s3.63-8.09,8.09-8.09,8.09,3.63,8.09,8.09-3.63,8.09-8.09,8.09ZM73.91,36.79c-3.09,0-5.61,2.51-5.61,5.61s2.52,5.61,5.61,5.61,5.61-2.52,5.61-5.61-2.51-5.61-5.61-5.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.38,72.13c-4.46,0-8.09-3.63-8.09-8.09s3.63-8.09,8.09-8.09,8.09,3.63,8.09,8.09-3.63,8.09-8.09,8.09ZM49.38,58.43c-3.09,0-5.61,2.52-5.61,5.61s2.51,5.61,5.61,5.61,5.61-2.51,5.61-5.61-2.52-5.61-5.61-5.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.02,93.21l-2.35-.81c.04-.12,4.21-12.27,3.47-21.41l2.47-.2c.79,9.66-3.41,21.9-3.59,22.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.68,74.29c-4.74,0-7.86-.89-8.13-.97l.71-2.38c.14.04,13.98,3.97,28.18-5.63l1.39,2.06c-8.32,5.62-16.41,6.93-22.14,6.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.67,56.89c-.65-11.91-7.86-19.68-7.93-19.75l1.8-1.71c.32.34,7.9,8.47,8.61,21.32l-2.48.14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.69,40.55c-5.77-6.67-23.46-7.29-23.64-7.29l.08-2.48c.77.02,18.95.66,25.44,8.15l-1.88,1.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.24,61.95l-1.49-1.99c4.55-3.41,12-9.86,12.63-12.65l2.42.55c-1.04,4.59-12.28,13.13-13.56,14.09Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.01,60.31c-3.05-4.24-12.8-12.66-12.9-12.74l1.62-1.88c.41.35,10.07,8.69,13.29,13.17l-2.02,1.45Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.2,37.25l-2.47-.27c.04-.32.92-8.03,5.8-13.77l1.89,1.61c-4.39,5.16-5.22,12.36-5.23,12.43Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.48,24.62c-2.24-3.03-8.17-8.3-8.23-8.36l1.65-1.86c.25.22,6.19,5.5,8.58,8.74l-2,1.47Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.9,34.46l-.61-2.41c.59-.15,14.56-3.67,20.74-3.44l-.09,2.48c-5.96-.22-19.9,3.33-20.04,3.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjustesIcon);
export default __webpack_public_path__ + "static/media/ajustesIcon.5722fb92db28d387c3cda87bf152b0cb.svg";
export { ForwardRef as ReactComponent };